import React, {useState, useEffect, FC} from 'react';
import {Row} from '../../../../../components/layout';
import './styles.scss';
import * as fonts from '../../../../../util/fonts';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {labelsParagraphs} from '../../../../../util/utility';
import AppParagraph from '../../../../../components/app-paragraph';
import AppButton from '../../../../../components/app-button';

interface SearchFieldsProps {
  inputName?: string;
  locationName?: string;
}

interface ResultsProps {
  searchFields: SearchFieldsProps;
  categories: CategoryProps[];
  medics: MedicsProps;
  clinics: ClinicsProps;
  optics: ClinicsProps;
  wellBeing: ClinicsProps;
  alternativeKeywords: any[];
  numberOfResults: number;
  nextStage(
    code: any,
    name: any,
    categoryCode: number,
    specialtyCode?: number
  ): any;
  nextStageClinics(code: any, name: any): any;
  nextStageMedics(code: any): any;
  nextStageClinicsNotGrouped(code: any, selectedClinicSection: string): any;
  handleOnSuggestionClick(values: any): any;
  setLocalHistory(values: any): any;
  getResultsLoadMore(take: any, categoryType: any, skip: any): void;
  localHistory: any;
  labels: any;
  buStyles: any;
}

interface CategoryProps {
  count: number;
  description: string;
  order: number;
  procedures: any[];
  catCode: number;
}

interface MedicsProps {
  count: number;
  medics: any[];
}

interface ClinicsProps {
  count: number;
  clinics: any[];
}

const NewResults: FC<ResultsProps> = ({
  numberOfResults,
  buStyles,
  nextStage,
  nextStageClinics,
  nextStageMedics,
  nextStageClinicsNotGrouped,
  handleOnSuggestionClick,
  setLocalHistory,
  getResultsLoadMore,
  localHistory,
  categories,
  clinics,
  medics,
  optics,
  wellBeing,
  alternativeKeywords,
  labels,
}) => {
  labelsParagraphs(labels);

  const [seeMoreToggled, setSeeMoreToggled] = useState([]);

  const suggestionWords = alternativeKeywords
    ? alternativeKeywords.slice(0, 3)
    : [];

  //useEffect to reset the verMais buttons that are toggled when a new search is made
  useEffect(() => {
    setSeeMoreToggled([]);
  }, [categories, clinics, medics, optics, wellBeing]);

  const handleOnClickToStage2 = (
    code: any,
    name: any,
    categoryCode: number,
    specialtyCode?: number
  ) => {
    setLocalHistory([...localHistory, 'stage2']);
    nextStage(code, name, categoryCode, specialtyCode);
  };

  const procedureTypeButtonBehaviour = (procedureType: any) => {
    const toggled = seeMoreToggled.find((el: any) => el === procedureType);
    let aux: any = [...seeMoreToggled, procedureType];
    setSeeMoreToggled(aux);
    if (toggled) {
      switch (procedureType) {
        case 'Medicos':
          medics.medics = medics.medics.slice(0, 6);
          renderMedics();
          break;
        case 'Clinicas':
          clinics.clinics = clinics.clinics.slice(0, 6);
          renderClinics(clinics, false, false);
          break;
        case 'BemEstar':
          wellBeing.clinics = wellBeing.clinics.slice(0, 6);
          renderClinics(wellBeing, false, true);
          break;
        case 'Opticas':
          optics.clinics = optics.clinics.slice(0, 6);
          renderClinics(optics, true, false);
          break;
        case 'Exames':
        case 'Cirurgias':
        case 'Consultas':
          const indexes: any = Object.keys(categories).find(
            (el: any) => categories[el].description === procedureType
          );
          categories[indexes].procedures = categories[indexes].procedures.slice(
            0,
            6
          );
          renderCategories();
          break;
        default:
          break;
      }
      const newArray = seeMoreToggled.filter((el: any) => el !== procedureType);
      setSeeMoreToggled(newArray);
    } else {
      getResultsLoadMore(12, procedureType, 6);
    }
  };

  const handleSeeMoreClick = (procedureType: any) => {
    procedureTypeButtonBehaviour(procedureType);
  };

  const renderSeeMoreButton = (procedureType: any) => {
    const found = seeMoreToggled.find((el: any) => el === procedureType);
    return (
      <AppButton
        onClick={() => {
          handleSeeMoreClick(procedureType);
        }}
        className="see-more-button"
        style={{...fonts.SM, ...fonts.SemiBold}}>
        {found
          ? labels?.medicalNetwork_see_less
          : labels?.medicalNetwork_see_more}
      </AppButton>
    );
  };

  const renderCategories = () => {
    const categoriesOrdered = categories?.sort(
      (a: CategoryProps, b: CategoryProps) => {
        if (a.order > b.order) {
          return 1;
        }
        if (a.order < b.order) {
          return -1;
        }
        return 0;
      }
    );

    return categoriesOrdered?.map(
      (c: CategoryProps) =>
        c.procedures.length !== 0 && (
          <div className="category" key={c.description}>
            <Row className="theme-title">
              {c.description}
              {c.count > 6 && renderSeeMoreButton(c.description)}
            </Row>
            <div className="options-container">
              {c.procedures.map((procedure: any) => (
                <>
                  <div className="option" key={procedure.name}>
                    <div
                      className="option-title"
                      style={{
                        ...fonts.ML,
                        ...fonts.Bold,
                        color: buStyles.primaryColor,
                      }}
                      onClick={() => {
                        handleOnClickToStage2(
                          procedure.code,
                          procedure.name,
                          procedure.category.code,
                          procedure.category.code ===
                            parseInt(labels.medicalNetwork_exams_code) &&
                            procedure.speciality.code
                        );
                      }}>
                      {procedure.name}
                    </div>
                    <div className="option-subtitle">
                      {procedure.clinicsCount}{' '}
                      {+procedure.clinicsCount === 1
                        ? labels?.medicalNetwork_locations1
                        : labels?.medicalNetwork_locations}{' '}
                    </div>
                  </div>
                </>
              ))}
            </div>
            {seeMoreToggled.find((el: any) => el === c.description) &&
              c.count > c.procedures.length && (
                <Row className="load-more-button-row">
                  <AppButton
                    onClick={() => {
                      getResultsLoadMore(
                        12,
                        c.description,
                        c.procedures.length
                      );
                    }}
                    className="load-more-button"
                    style={{...fonts.MM, ...fonts.Bold}}>
                    {labels?.medicalNetwork_load_more}
                  </AppButton>
                </Row>
              )}
          </div>
        )
    );
  };

  const handleOnClickNotGrouped = (code: any, mappedObject: any) => {
    setLocalHistory([...localHistory, 'stage2Clinics']);
    nextStageClinicsNotGrouped(code, mappedObject);
  };

  const handleOnClickClinics = (nameHash: any, name: any) => {
    setLocalHistory([...localHistory, 'stage2']);
    nextStageClinics(nameHash, name);
  };

  const formatLocation = (parish?: string, city?: string): string => {
    if (parish && city) return `${parish}, ${city}`;
    return parish || city || '';
  };

  const renderClinics = (
    mappedObject: any,
    optics: boolean,
    wellBeing: boolean
  ) => {
    const clinicType = optics ? 'Opticas' : wellBeing ? 'BemEstar' : 'Clinicas';
    return (
      <>
        {mappedObject?.clinics?.length !== 0 && (
          <div className="category">
            <Row className="theme-title">
              {optics
                ? labels?.medicalNetwork_optics
                : wellBeing
                ? labels?.medicalNetwork_wellBeing
                : labels?.medicalNetwork_clinics}
              {mappedObject?.count > 6 && renderSeeMoreButton(clinicType)}
            </Row>
            <div className="options-container">
              {mappedObject?.clinics?.map((c: any) => (
                <div className="option" key={c.name}>
                  {c.grouped ? (
                    <div
                      className="option-title"
                      onClick={() => handleOnClickClinics(c.nameHash, c.name)}
                      style={{
                        ...fonts.ML,
                        ...fonts.Bold,
                        color: buStyles.primaryColor,
                      }}>
                      {c.name}
                    </div>
                  ) : (
                    <div
                      className="option-title"
                      onClick={() =>
                        handleOnClickNotGrouped(c.code, mappedObject?.clinics)
                      }
                      style={{
                        ...fonts.ML,
                        ...fonts.Bold,
                        color: buStyles.primaryColor,
                      }}>
                      {c.name}
                    </div>
                  )}
                  <div className="option-subtitle">
                    {formatLocation(c.parish, c.city)}
                  </div>{' '}
                </div>
              ))}
            </div>
          </div>
        )}
        {seeMoreToggled.find((el: any) => el === clinicType) &&
          mappedObject?.count > mappedObject?.clinics?.length && (
            <Row className="load-more-button-row">
              <AppButton
                onClick={() => {
                  getResultsLoadMore(
                    12,
                    clinicType,
                    mappedObject?.clinics?.length
                  );
                }}
                className="load-more-button"
                style={{...fonts.MM, ...fonts.Bold}}>
                {labels?.medicalNetwork_load_more}
              </AppButton>
            </Row>
          )}
      </>
    );
  };

  const handleOnClickMedics = (code: any) => {
    setLocalHistory([...localHistory, 'stage2Medics']);
    nextStageMedics(code);
  };

  const renderMedics = () => {
    return (
      <>
        {medics?.medics?.length !== 0 && (
          <div className="category">
            <Row className="theme-title">
              {labels?.medicalNetwork_medics}
              {medics?.count > 6 && renderSeeMoreButton('Medicos')}
            </Row>
            <div className="options-container">
              {medics?.medics?.map((m: any) => (
                <div className="option" key={m.name}>
                  <div
                    className="option-title"
                    style={{
                      ...fonts.ML,
                      ...fonts.Bold,
                      color: buStyles.primaryColor,
                    }}
                    onClick={() => handleOnClickMedics(m.code)}>
                    {m.name}
                  </div>
                  <div className="option-subtitle">
                    {m.speciality?.description}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
        {seeMoreToggled.find((el: any) => el === 'Medicos') &&
          medics?.count > medics?.medics?.length && (
            <Row className="load-more-button-row">
              <AppButton
                onClick={() => {
                  getResultsLoadMore(12, 'Medicos', medics?.medics?.length);
                }}
                className="load-more-button"
                style={{...fonts.MM, ...fonts.Bold}}>
                {labels?.medicalNetwork_load_more}
              </AppButton>
            </Row>
          )}
      </>
    );
  };

  const renderSuggestions = () => {
    return (
      <Row style={{...fonts.M}}>
        {`${labels?.medicalNetwork_didYouMean}`}
        {suggestionWords.map((el: any) => {
          return (
            <>
              <p
                className="suggestion-element"
                style={{...fonts.Bold, color: buStyles.primaryColor}}
                onClick={() => handleOnSuggestionClick(el)}>
                {`${el}`}
              </p>
              <p style={{...fonts.M}}>
                {suggestionWords.indexOf(el) === suggestionWords.length - 1
                  ? '.'
                  : ','}
              </p>
            </>
          );
        })}
      </Row>
    );
  };

  return (
    <React.Fragment>
      <div className="results">
        {numberOfResults === 0 && (
          <div className="sugestion-container">
            {suggestionWords.length > 0 && renderSuggestions()}
            <span style={{...fonts.M}}>
              {labels?.medicalNetwork_noResults_suggestion1}
            </span>
            <span style={{...fonts.M, ...fonts.SemiBold}}>
              {labels?.medicalNetwork_noResults_suggestion2}
            </span>
            <p style={{...fonts.M}}>
              {labels?.medicalNetwork_noResults_suggestion3}
            </p>
            <AppParagraph
              label={labels?.medicalNetwork_noResults_suggestion4}
              style={{...fonts.M}}
            />
          </div>
        )}

        {numberOfResults > 0 && (
          <div id="category-rows" className="category-rows">
            {renderCategories()}
            {renderClinics(clinics, false, false)}
            {renderMedics()}
            {renderClinics(optics, true, false)}
            {renderClinics(wellBeing, false, true)}
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = ({globalStyles, strings}: any) => ({
  buStyles: globalStyles.value,
  labels: strings.value.pt.rede,
});

export default compose(connect(mapStateToProps)(NewResults));
